/*@flow*/
import type { Node } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import React from 'react';

type Triggers = 'hover' | 'click';

type PropsT = {
  content?: React$Node,
  overlay?: React$Node,
  children: React$Node,
  disabled?: boolean,
  placement: string,
  trigger?: Triggers[],
  id: ID,
  innerProps?: Object,
  rootClose?: boolean,
  defaultShow?: boolean,

  hidden?: boolean,
  overrideTestHack?: boolean,
};

export default (
  Component: any
): ((props: PropsT) => null | React$Node | Node) => (props: PropsT) => {
  const {
    hidden,
    content,
    overlay,
    disabled,
    children,
    id,
    innerProps,
    placement,
    trigger,
    overrideTestHack = false,
    ...rest
  } = props;
  if (hidden) return null;
  if (!(content || overlay)) return null;
  if (disabled) return children;
  if (!overrideTestHack) {
    if (process.env.NODE_ENV === 'test') return children;
  }
  const element = (
    <Component id={id} {...innerProps || {}}>
      {content || overlay}
    </Component>
  );

  return (
    <OverlayTrigger
      {...rest}
      placement={placement}
      trigger={trigger || ['hover', 'click']}
      overlay={element}
    >
      {children}
    </OverlayTrigger>
  );
};
